import { defineStore } from "pinia";

export const useCollectionsStore = defineStore("collectionsStore", {
  state: () => ({
    selectedCollection: [],
    collections: [],
    EditProductCollectionId: null,
    collectionToCreate: null,
    getCollectionProductsTrigger: 0,
    isLoadingDemoCollections: false,
    collectionsSearchValue: "",
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    decrementCollection(collectionId) {
      const mainIndex = this.collections.findIndex((item) => item.id === collectionId);
      const newCount = this.collections[mainIndex]?.count - 1;
      if (mainIndex !== -1) {
        const updated = {
          ...this.collections[mainIndex],
          count: newCount,
        };
        this.collections.splice(mainIndex, 1, updated);
      }

      const selectedIndex = this.selectedCollection.findIndex((item) => item.id === collectionId);
      if (selectedIndex !== -1) {
        const updated = {
          ...this.selectedCollection[selectedIndex],
          count: newCount,
        };
        this.selectedCollection.splice(selectedIndex, 1, updated);
      }
    },
    incrementCollection(collectionId) {
      const mainIndex = this.collections.findIndex((item) => item.id === collectionId);
      const newCount = mainIndex !== -1 ? this.collections[mainIndex].count + 1 : null;
      if (mainIndex !== -1) {
        const updated = {
          ...this.collections[mainIndex],
          count: newCount,
        };
        this.collections.splice(mainIndex, 1, updated);
      }

      const selectedIndex = this.selectedCollection.findIndex((item) => item.id === collectionId);
      if (selectedIndex !== -1 && newCount !== null) {
        const updated = {
          ...this.selectedCollection[selectedIndex],
          count: newCount,
        };
        this.selectedCollection.splice(selectedIndex, 1, updated);
      }
    },
    addCollection(newCollection) {
      this.collections.push(newCollection);
    },
    deleteCollection(collectionToDelete) {
      this.collections = this.collections.filter((collection) => collection.key !== collectionToDelete.key);
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    DECREMENT_COLLECTION(collectionId) {
      this.decrementCollection(collectionId);
    },
    INCREMENT_COLLECTION(collectionId) {
      this.incrementCollection(collectionId);
    },
    ADD_COLLECTION(newCollection) {
      this.addCollection(newCollection);
    },
    DELETE_COLLECTION(collectionToDelete) {
      this.deleteCollection(collectionToDelete);
    },
  },
});

export default useCollectionsStore;
